/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientIdentifierName from './patient-identifier-name';
import PatientIdentifierNameDetail from './patient-identifier-name-detail';
import PatientIdentifierNameUpdate from './patient-identifier-name-update';
import PatientIdentifierNameDeleteDialog from './patient-identifier-name-delete-dialog';

const PatientIdentifierNameRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientIdentifierName />} />
    <Route path="new" element={<PatientIdentifierNameUpdate />} />
    <Route path=":id">
      <Route index element={<PatientIdentifierNameDetail />} />
      <Route path="edit" element={<PatientIdentifierNameUpdate />} />
      <Route path="delete" element={<PatientIdentifierNameDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientIdentifierNameRoutes;
